import { useCallback, useEffect, useRef, useState } from "react";

export function useCountdown(initialCount: number, onComplete: () => void): { countdown: number; start: () => void } {
    const [countdown, setCountdown] = useState(initialCount);
    const [active, setActive] = useState(false);
    const onCompleteRef = useRef(onComplete);

    useEffect(() => {
        onCompleteRef.current = onComplete;
    });

    useEffect(() => {
        if (!active || countdown === 0) {
            return;
        }

        const timer = setTimeout(() => {
            setCountdown((c) => c - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [active, countdown]);

    useEffect(() => {
        if (active && countdown === 0) {
            onCompleteRef.current();
        }
    }, [active, countdown]);

    const start = useCallback(() => setActive(true), []);

    return { countdown, start };
}
